/* This file is autogenerated, see readme.md for instructions */
import ConsoleSvgIcon from '@bloomreach/banana-theme/icons/console.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ConsoleIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ConsoleSvgIcon />
    </Icon>
  );
});

ConsoleIcon.displayName = 'ConsoleIcon';

export default ConsoleIcon;
